import { CommonEnums } from '../../common.enums';

export class Comment_Inst {
    comment_Inst_Id: number;
    parentObj_Id: number;
    parentObj_Cd: string;
    nm: string;
    comment: string;
    height: number;
    width: number;
    updateDt: Date;
    updateBy: string;
    lastUpdateBy: string;
    x: number;
    y: number;

    constructor() {
        this.comment_Inst_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.parentObj_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.parentObj_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.comment = CommonEnums.defaults.STRING_EMPTY;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.height = 30;
        this.width = 100;
        this.x = 0;
        this.y = 0;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(comment_InstTmp: any): Comment_Inst {
        let canvascomment = new Comment_Inst();
        canvascomment.copyFrom(comment_InstTmp);
        return canvascomment;
    }

    copy(): Comment_Inst {
        let comment_InstTmp = new Comment_Inst;

        comment_InstTmp.comment_Inst_Id = this.comment_Inst_Id;
        comment_InstTmp.parentObj_Cd = this.parentObj_Cd;
        comment_InstTmp.parentObj_Id = this.parentObj_Id;
        comment_InstTmp.nm = this.nm;
        comment_InstTmp.x = this.x;
        comment_InstTmp.y = this.y;
        comment_InstTmp.comment = this.comment;
        comment_InstTmp.height = this.height;
        comment_InstTmp.width = this.width;
        comment_InstTmp.updateBy = this.updateBy;
        comment_InstTmp.lastUpdateBy = this.lastUpdateBy;
        comment_InstTmp.updateDt = this.updateDt;

        return comment_InstTmp;
    }

    copyFrom(comment_InstTmp: Comment_Inst): void {
        this.comment_Inst_Id = comment_InstTmp.comment_Inst_Id;
        this.parentObj_Cd = comment_InstTmp.parentObj_Cd;
        this.parentObj_Id = comment_InstTmp.parentObj_Id;
        this.nm = comment_InstTmp.nm;
        this.x = comment_InstTmp.x;
        this.y = comment_InstTmp.y;
        this.comment = comment_InstTmp.comment;
        this.height = comment_InstTmp.height;
        this.width = comment_InstTmp.width;
        this.updateBy = comment_InstTmp.updateBy;
        this.lastUpdateBy = comment_InstTmp.lastUpdateBy;
        this.updateDt = comment_InstTmp.updateDt;
    }

    compare(comment_InstTmp: Comment_Inst): string {
        let canvasCommentString: string = this.toString();
        let canvasCommentTmpString: string = comment_InstTmp.toString();

        if (canvasCommentString != canvasCommentTmpString) {
            return canvasCommentString + ', ' + canvasCommentTmpString
        }
        return '';
    }

    toString(): string {
        let str = "Comment_Inst[comment_Inst_Id" + this.comment_Inst_Id + "parentObj_Cd" + this.parentObj_Cd + "parentObj_Id" + this.parentObj_Id + "nm" +
            this.nm + "x" + this.x + "y" + this.y + "comment" + this.comment + "height" + this.height + "width" + this.width + "updateBy" + this.updateBy + "lastUpdateBy" +
            this.lastUpdateBy + "updateDt" + this.updateDt + "]";

        return str;
    }

}